<!--
  Celebratory bunting across the top of a Dialog's success state.

  Bleeds to the dialog's physical edges and clips on the rounded corners via
  the dialog's own `overflow: hidden`. Absolutely positioned so it neither
  pushes siblings nor triggers overflow — position is relative to the dialog
  element, which is `position: fixed`.

  Spanning the full top edge means it runs under the close button in the
  corner. Dialog.vue owns both halves of that: the button is lifted above it
  with a z-index, and its glyph carries a halo in the dialog's own background
  colour so it stays legible where the bunting passes behind.

  Content that follows it needs to clear roughly 82/691 × dialog width of
  height; see the `.success` rules in the dialogs that use it.
-->
<template>
  <div class="garland" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 238 691 82" fill="none" width="100%">
      <path d="M88.2537 256.938C105.52 299.566 101.673 290.112 106.482 301.849L132.153 262.664C117.313 263.008 102.509 261.077 88.2537 256.938Z" fill="#0D4D80" fill-opacity="0.7"/>
      <path d="M403.281 266.405C428.481 304.879 422.874 296.35 429.866 306.932L447.457 263.516C432.966 266.729 418.068 267.703 403.281 266.405Z" fill="#0D4D80" fill-opacity="0.7"/>
      <path d="M456.041 266.217C480.817 304.965 475.304 296.375 482.18 307.033L500.246 263.812C485.72 266.866 470.812 267.677 456.041 266.217Z" fill="#0D4D80"/>
      <path d="M508.253 264.697C533.876 302.89 528.175 294.424 535.284 304.928L552.395 261.32C537.94 264.693 523.053 265.832 508.253 264.697Z" fill="#008ECF"/>
      <path d="M560.842 262.959C588.195 299.933 582.111 291.738 589.696 301.904L604.782 257.555C590.497 261.589 575.678 263.412 560.842 262.959Z" fill="#0D4D80" fill-opacity="0.7"/>
      <path d="M615.642 259.878C644.435 295.742 638.032 287.794 646.012 297.652L659.334 252.742C645.22 257.338 630.485 259.744 615.642 259.878Z" fill="#0D4D80"/>
      <path d="M353.252 267.403C377.827 306.278 372.359 297.66 379.18 308.353L397.469 265.227C382.927 268.205 368.016 268.939 353.252 267.403Z" fill="#008ECF"/>
      <path d="M302.345 266.431C324.619 306.669 319.661 297.747 325.849 308.819L346.614 266.828C331.923 268.957 316.994 268.823 302.345 266.431Z" fill="#0D4D80"/>
      <path d="M195.263 264.517C217.537 304.755 212.579 295.833 218.767 306.905L239.532 264.914C224.841 267.043 209.912 266.909 195.263 264.517Z" fill="#008ECF"/>
      <path d="M143.445 261.769C163.567 303.126 159.086 293.955 164.681 305.338L187.631 264.5C172.849 265.851 157.948 264.93 143.445 261.769Z" fill="#0D4D80"/>
      <path d="M249.546 265.79C271.82 306.028 266.862 297.107 273.05 308.178L293.815 266.188C279.125 268.316 264.195 268.182 249.546 265.79Z" fill="#0D4D80" fill-opacity="0.7"/>
      <path d="M33.8479 253.554C52.3476 295.661 48.2262 286.324 53.3751 297.915L77.8948 258C63.0716 258.776 48.2171 257.276 33.8479 253.554Z" fill="#008ECF"/>
      <path d="M10.1429 251.578C10.1429 251.578 24.2064 252.758 33.3241 253.47C257.76 271.006 432.394 269.831 659.537 253.47C669.398 252.76 684.623 251.578 684.623 251.578" stroke="#CACACA" stroke-width="12" stroke-linecap="round"/>
    </svg>
  </div>
</template>

<style scoped lang="css">
.garland {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;

  /* Decoration, and it covers the close button's corner — so it must never be
     the thing a tap lands on. The z-index on button.close already puts the
     button in front; this is the half that does not depend on anyone keeping
     these two stacking rules in sync. */
  pointer-events: none;

  svg {
    display: block;
  }
}
</style>
